import { collectorRoutePaths } from '@/views/collector-route-paths';
import type { NeonTabModel } from '@arcual/lib-app-neon';

const aboutMenuTabs = ['site', 'help', 'privacy', 'terms'];

export const aboutMenu = (): Array<NeonTabModel> =>
  aboutMenuTabs.map((key) => ({
    key,
    href: `${collectorRoutePaths.ABOUT}/${key}`,
    label: `storefront.app.about.${key}.title`,
  }));
